import { values } from 'lodash'
import PropTypes from 'prop-types'

import { idPropType } from '../../common/prop-types'

import { INGREDIENT_SPECIAL_CASE_TYPES } from '../constants'

const ingredientSpecialCasePropType = PropTypes.shape({
  id: idPropType.isRequired,
  name: PropTypes.string.isRequired,
  type: PropTypes.oneOf(values(INGREDIENT_SPECIAL_CASE_TYPES)).isRequired,
  description: PropTypes.string,
  caseDefinition: PropTypes.string,
})

export default ingredientSpecialCasePropType
